(function () {

    "use strict";

    function headEditController( ) {

    }

    headEditController.$inject = [];

    angular.module("sphforms.main")
        .component("sphformsHeadEdit", {
            controller: headEditController,
            bindings: {
                idEntity: "<",
                title: "=",
                entity: "="
            },
            templateUrl: "modules/main/components/ui/basicEdit/headEdit/headEdit.template.html"
        });

}());